import { useEffect } from 'react';
import { seoDefaults } from '../data/seo';

type PageMeta = { title: string; description: string; image?: string };

/** Sets the document title plus description, Open Graph and Twitter tags for the current page. */
export function usePageMeta({ title, description, image = seoDefaults.image }: PageMeta) {
  useEffect(() => {
    document.title = title;
    const url = window.location.href;
    setMeta('name', 'description', description);
    setMeta('property', 'og:type', 'website');
    setMeta('property', 'og:site_name', seoDefaults.siteName);
    setMeta('property', 'og:title', title);
    setMeta('property', 'og:description', description);
    setMeta('property', 'og:image', image);
    setMeta('property', 'og:url', url);
    setMeta('property', 'og:locale', seoDefaults.locale);
    setMeta('name', 'twitter:card', 'summary_large_image');
    setMeta('name', 'twitter:title', title);
    setMeta('name', 'twitter:description', description);
    setMeta('name', 'twitter:image', image);
  }, [title, description, image]);
}

function setMeta(attr: 'name' | 'property', key: string, content: string) {
  let el = document.head.querySelector<HTMLMetaElement>(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}
